import { Box, Drawer } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineMail } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import registrationIcon from "../../assets/Registration/Registration icon.svg";
import dropdown from "../../assets/Registration/bi_chevron-expand.svg";
import logo from "../../assets/dashboard/header icon.svg";
import CountryModal from "../../common/country_modal/countryModal";
import {
  userRegistration,
  userRegistrationNew,
} from "../../services/authServices";
import style from "./Registration.module.css";
import OtpVerification from "./otpVerification";
import PrivacyAndPolicy from "./privacyAndPolicy";
import TermsOfUse from "./termsOfUse";
import { T3_LOGO } from "../../constants";
import Header from "../../common/Header";

let errInputStyle = {
  color: "red",
  fontSize: "0.7rem",
  marginLeft: "1rem",
  // marginTop: "-12px",
  background: "#fff",
  width: "max-content",
  padding: "2px 4px",
};

export default function Registration() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm();

  const [termsOfUseModalOpen, setTermsOfUseModalOpen] = useState(false);
  const [iscountryCode, setIscountryCode] = useState(false);
  const [isPasswordModal, setIsPasswordModal] = useState(false);
  const [isOTPModal, setIsOTPModal] = useState(false);
  const [PrivacyAndPolicyModal, setPrivacyAndPolicyModal] = useState(false);
  const [registrationData, setRegistrationData] = useState();
  const [allCountries, setAllCountries] = useState([]);
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();

  const countryData = useSelector((state) => state.getCountries.result);

  const getCountryState = ({
    country_code,
    country_name,
    flag: flag_image,
  }) => {
    setValue("country_code", `+${country_code}`);

    setRegistrationData((prev) => ({
      ...prev,
      country_code,
      country_name,
      flag: flag_image,
    }));
  };

  const onSubmit = (data) => {
    setRegistrationData((prev) => ({ ...prev, data }));
    callRegistrationApi(data);
  };

  const callRegistrationApi = async (data) => {
    try {
      const request = await userRegistrationNew({ ...data, host: "t3" });
      const response = await request.data;
      if (response.status === 1) {
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        setUserId(response?.data?.user_id);
        localStorage.setItem("userId", response?.data?.user_id);
        setIsOTPModal(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // callAllCountries();
  }, []);

  useMemo(() => {
    setAllCountries(countryData?.data);
    let defaultCountry = countryData?.data?.find((x) => x.name === "Singapore");
    getCountryState({
      country_code: defaultCountry?.callingCodes,
      country_name: defaultCountry?.name,
      flag: defaultCountry?.flag,
    });
  }, [countryData]);

  return (
    <Box className={style.container}>
      <Drawer open={iscountryCode} anchor="bottom">
        <CountryModal
          defaultSelected={registrationData?.country_name}
          close={setIscountryCode}
          data={allCountries}
          setState={getCountryState}
        />
      </Drawer>

      <Drawer open={PrivacyAndPolicyModal} anchor="top">
        <PrivacyAndPolicy close={setPrivacyAndPolicyModal} />
      </Drawer>
      <Drawer open={termsOfUseModalOpen} anchor="top">
        <TermsOfUse close={setTermsOfUseModalOpen} />
      </Drawer>

      <Drawer
        open={isOTPModal}
        anchor="bottom"
        onClose={() => setIsOTPModal(false)}
        PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
      >
        <OtpVerification
          user_id={userId}
          setIsPasswordModal={setIsPasswordModal}
        />
      </Drawer>

      {/*    header */}
      <Header canGoBack={false}  header="Registration" canRedirectToHome={false} />
      {/* <Box className={style.header_container}>
        <h4>Registration</h4>
        <img src={T3_LOGO} alt="T3 Visas logo" />
      </Box> */}
      {/*   main contain */}
      <Box sx={{ padding: "1rem" }} className={style.main_container}>
        <Box className={style.registration_container}>
          <Box className={style.registrationIcon_section}>
            <img src={registrationIcon} alt="icon" />
          </Box>
          <form>
            <Box className={style.registration_box_field}>
              <p>
                First Name <span className={style.importantField}>*</span>
              </p>
              <input
                type="text"
                defaultValue={registrationData?.first_name}
                {...register("first_name", {
                  required: "First name is required!",
                  minLength: {
                    value: 2,
                    message: "First name should be atleast 2 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z]+$/i,
                    message: "First name should contain only letters",
                  },
                })}
                autoComplete="off"
              />
            </Box>
            {errors.first_name && (
              <p style={{ ...errInputStyle }}>{errors.first_name?.message}</p>
            )}
            <Box className={style.registration_box_field}>
              <p>
                Last Name <span className={style.importantField}>*</span>
              </p>
              <input
                type="text"
                defaultValue={registrationData?.last_name}
                {...register("last_name", {
                  required: "Last name is required!",
                  minLength: {
                    value: 2,
                    message: "Last name should be atleast 2 characters",
                  },
                  pattern: {
                    value: /^[A-Za-z]+$/i,
                    message: "Last name should contain only letters",
                  },
                })}
              />
            </Box>

            {errors.last_name && (
              <p style={{ ...errInputStyle }}>{errors.last_name?.message} </p>
            )}
            <Box
              className={style.registration_box_field}
              style={{ marginRight: "2px" }}
            >
              <p>
                Mobile Number <span className={style.importantField}>*</span>
              </p>
              <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <img
                  src={registrationData?.flag}
                  className="flag"
                  alt={`${registrationData?.name} flag`}
                  // style={{ width: "2rem", marginRight: "0.5rem" }}
                  onClick={() => {
                    setIscountryCode(true);
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    paddingRight: "0.2rem",
                  }}
                  onClick={() => {
                    setIscountryCode(true);
                  }}
                >
                  <span className={style.mobile_code_field}>
                    + {registrationData?.country_code}
                  </span>
                  <img
                    src={dropdown}
                    style={{ width: "1rem" }}
                    alt="dropdown icon"
                  />
                </div>
                <input
                  // style={{ marginLeft: "0.5rem" }}
                  type="tel"
                  defaultValue={registrationData?.mobile_no}
                  {...register("mobile_no", {
                    required: "Mobile number is required",
                    minLength: {
                      value: 2,
                      message: "At least 2 digits are required",
                    },
                    maxLength: {
                      value: 12,
                      message: "Mobile number cannot exceed 12 digits",
                    },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Only numbers are allowed",
                    },
                  })}
                  autoComplete="off"
                />
              </Box>
            </Box>

            {errors.mobile_no && (
              <p style={{ ...errInputStyle }}>{errors.mobile_no?.message}</p>
            )}

            <Box className={style.registration_box_field}>
              <p>
                Email <span className={style.importantField}>*</span>
              </p>
              <Box style={{ display: "flex", alignItems: "center", gap: 5 }}>
                <AiOutlineMail style={{ width: "1.5rem" }} />
                <input
                  type="email"
                  defaultValue={registrationData?.email}
                  {...register("email", {
                    required: "Email Address is required!",
                    validate: {
                      matchPattern: (v) =>
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                        "Please Enter Valid Email address",
                    },
                  })}
                  autoComplete="off"
                />
              </Box>
            </Box>
            {errors.email && (
              <p style={{ ...errInputStyle }}>{errors.email.message}</p>
            )}
            <Box
              className={style.registration_check_box}
              sx={{ marginTop: "1rem" }}
            >
              <input
                type="checkbox"
                {...register("checked", {
                  required: "Please accept privacy and policy",
                })}
              />
              <p>
                I accept the
                <span onClick={() => setTermsOfUseModalOpen(true)}>
                  {" "}
                  User Agreement{" "}
                </span>
                & have read the
                <span onClick={() => setPrivacyAndPolicyModal(true)}>
                  {" "}
                  Privacy Policy
                </span>
              </p>
            </Box>
            {errors.checked && (
              <p
                style={{
                  ...errInputStyle,
                  marginTop: "2px",
                  backgroundColor: "transparent",
                }}
              >
                {errors.checked?.message}
              </p>
            )}
          </form>
        </Box>
        {/* bottom section */}
        <Box className={style.btn_section}>
          <button
            type="submit"
            onClick={handleSubmit(onSubmit)}
            className={style.btn}
            // disabled={!isValid}
            style={{ backgroundColor: "#7F3F97", color: "white" }}
          >
            Confirm & Proceed
          </button>
          <p>
            Please <span onClick={() => navigate("/login")}>Login</span> if you
            are already registered
          </p>
        </Box>
      </Box>
    </Box>
  );
}
